"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var React = require('react');
var PropTypes = require('prop-types');
/*
*  -------- IMPORTANT --------
*  If you change this, please browserify the following components:
*  - transactable
* */
var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);
  function Modal(props) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _callSuper(this, Modal, [props]);
    _this.state = {
      scrollPosition: null
    };
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.openModal = _this.openModal.bind(_assertThisInitialized(_this));
    _this.renderHeader = _this.renderHeader.bind(_assertThisInitialized(_this));
    _this.renderSubheader = _this.renderSubheader.bind(_assertThisInitialized(_this));
    _this.renderBanner = _this.renderBanner.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var opts = {
        show: false,
        backdrop: 'static'
      };
      if (false === this.props.allowClickAway) {
        opts.backdrop = 'static';
      }

      // init modal, but don't open
      $('#modal-container').modal(opts);
      if (this.props.show) {
        // first call for modal, let's open it
        this.openModal();
      }

      // let's set the clickaway & close behavior to unmount component
      $('#modal-container').on('hidden.bs.modal', this.closeModal);

      // if a function, like analytic, needs to fire once Modal mounts, call it here
      if (this.props.didMountFunction) {
        this.props.didMountFunction();
      }
      var modalWidth = $('.modal-dialogue').width();
      var screenWidth = screen.width;
      var isFullScreen = modalWidth >= screenWidth || modalWidth !== 0;
      if (isFullScreen) {
        var scrollPosition = $(window).scrollTop();

        // save scroll position of document
        this.setState({
          scrollPosition: scrollPosition
        });

        // scroll to bottom
        window.scrollTo(0, document.body.scrollHeight);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // if top level component says close the modal, then close the modal
      if (!nextProps.show) {
        return this.closeModal();
      }
      // if modal needs to be opened again, let's open it
      if (nextProps.show) {
        return this.openModal();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $('#modal-container').off('hidden.bs.modal');
    }
  }, {
    key: "closeModal",
    value: function closeModal(event) {
      $('#modal-container').modal('hide');
      var scrollPosition = this.state.scrollPosition;
      var modalWidth = $('.modal-dialog').width();
      var screenWidth = screen.width;
      var isFullScreen = modalWidth >= screenWidth || modalWidth !== 0;

      // scroll to position if available
      if (scrollPosition && isFullScreen) {
        window.scrollTo(0, scrollPosition);
      }
      if (this.props.closeBehavior) {
        this.props.closeBehavior(event);
      }
    }
  }, {
    key: "openModal",
    value: function openModal() {
      $('#modal-container').modal();
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var modalType = this.props.modalType;
      switch (modalType) {
        case 'special':
          return /*#__PURE__*/React.createElement("h2", null, this.props.header);
        case 'trans':
          return /*#__PURE__*/React.createElement("h4", null, this.props.header);
        default:
          return /*#__PURE__*/React.createElement("h3", null, this.props.header);
      }
    }
  }, {
    key: "renderSubheader",
    value: function renderSubheader() {
      switch (this.props.modalType) {
        case 'special':
          return /*#__PURE__*/React.createElement("div", {
            className: "form-modal"
          }, this.props.subheader);
        default:
          return /*#__PURE__*/React.createElement("p", null, this.props.subheader);
      }
    }
  }, {
    key: "renderBanner",
    value: function renderBanner() {
      var _this$props$banner = this.props.banner,
        text = _this$props$banner.text,
        type = _this$props$banner.type;
      var bannerClass = "text-center header-banner ".concat(type);
      return /*#__PURE__*/React.createElement("div", {
        className: bannerClass
      }, text);
    }
  }, {
    key: "render",
    value: function render() {
      var headerCloseIcon;
      var headerClass;
      var headerText = null;
      var subHeaderText = null;
      var banner = null;
      var _this$props$showBanne = this.props.showBanner,
        showBanner = _this$props$showBanne === void 0 ? true : _this$props$showBanne;
      if (this.props.addCloseIcon) {
        headerCloseIcon = /*#__PURE__*/React.createElement("span", {
          className: "pull-right ico ico-sm icon-close-sidebar margin-lg-right",
          onClick: this.closeModal
        });
      }
      if (this.props.header) {
        headerText = this.renderHeader();
      }
      if (this.props.subheader) {
        subHeaderText = this.renderSubheader();
      }
      if (this.props.banner) {
        banner = this.renderBanner();
      }
      headerClass = 'modal-header text-center col-xs-12';
      return /*#__PURE__*/React.createElement("div", {
        id: this.props.modalID,
        className: "modal-dialogue ".concat(this.props.modalSize, " ").concat(this.props.modalClass || ''),
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-banner no-padding"
      }, showBanner && banner, headerCloseIcon), this.props.header || this.props.subheader ? /*#__PURE__*/React.createElement("div", {
        className: headerClass
      }, headerText, subHeaderText) : '', /*#__PURE__*/React.createElement("div", {
        id: "modal-body",
        className: "modal-body col-xs-12"
      }, this.props.body), this.props.footer ? /*#__PURE__*/React.createElement("div", {
        id: "modal-footer",
        className: "modal-footer col-xs-12"
      }, this.props.footer) : null));
    }
  }]);
  return Modal;
}(React.Component);
Modal.propTypes = {
  addCloseIcon: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  modalID: PropTypes.string.isRequired,
  modalSize: PropTypes.oneOf(['sm-size', 'md-size', 'lg-size']).isRequired,
  modalType: PropTypes.oneOf(['special', 'standard', 'trans']),
  modalClass: PropTypes.string,
  header: PropTypes.string,
  subheader: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  banner: PropTypes.shape({
    type: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  }),
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  didMountFunction: PropTypes.func,
  closeBehavior: PropTypes.func,
  allowClickAway: PropTypes.bool
};
Modal.defaultProps = {
  show: false,
  header: null,
  subheader: null,
  banner: null,
  body: null,
  footer: null,
  modalType: 'standard',
  addCloseIcon: true,
  grayHeaderBg: false
};
module.exports = {
  Modal: Modal
};